import React from 'react';
import SashiDo from 'lib/SashiDo';
import { addOrUpdate } from 'lib/helpers';
import GraphBuilds from 'dashboard/Metrics/Requests/GraphBuilds.react';
import DashboardView from 'dashboard/DashboardView.react';
import Icon from 'components/Icon/Icon.react';
import LoaderContainer from 'components/LoaderContainer/LoaderContainer.react';
import Button from 'components/Button/Button.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import SashiDoParse from '../SashiDoParse';
import styles from './Settings.scss';
import stylesEngine from './EngineView.scss';
import BuildsView from './BuildsView.react';


import RealTimeLogView from './RealTimeLogView.react';

const { SASHIDO_API_URL, SASHIDO_API_ID, SASHIDO_API_JS_KEY } = process.env;
const Build = SashiDoParse.Object.extend('Build');

export default class Builds extends DashboardView {
  constructor() {
    super();
    this.section = 'Runtime';
    this.subsection = 'Builds';

    this.state = {
      loading: true,
      runningBuild: false,
      liveQueries: {
        LatestCreatedBuild: {},
      },
    };

    this.subscriptionBuild = null;
  }

  async componentDidMount() {
    const appId = this.context.currentApp.id;
    const logs = await SashiDo.getBuilds({ appId });

    this.setState({
      logs,
    });

    const userObject = JSON.parse(window.localStorage.getItem(`SashiDo/${SASHIDO_API_ID}/currentUser`));
    const sessionToken = userObject ? userObject.sessionToken : '';

    this.client = new SashiDoParse.LiveQueryClient({
      applicationId: SASHIDO_API_ID,
      serverURL: SASHIDO_API_URL.replace('https', 'wss'),
      javascriptKey: SASHIDO_API_JS_KEY,
    });

    this.client.open();

    const queryBuild = new SashiDoParse.Query(Build);
    queryBuild.equalTo('app', { __type: 'Pointer', className: 'App', objectId: appId });
    this.subscriptionBuild = this.client.subscribe(queryBuild, sessionToken);

    // Build
    this.subscriptionBuild.on('create', (obj) => {
      const { liveQueries, logs: logsObj } = this.state;
      const newLogs = addOrUpdate(logsObj, 'objectId', { objectId: obj.id, ...obj.attributes });

      this.setState({
        logs: newLogs,
        liveQueries: {
          ...liveQueries,
          LatestCreatedBuild: { ...obj.attributes, objectId: obj.id },
        },
      });
    });

    this.subscriptionBuild.on('update', (obj) => {
      const { liveQueries, logs: logsObj } = this.state;

      const runningBuild = obj.attributes.phase !== 'Complete' ? { runningBuild: true } : {};
      const cancelled = obj.attributes.phase === 'Cancelled'
        ?
        {
          liveQueries: {
            LatestCreatedBuild: {},
          },
          runningBuild: false,
        }
        : {};

      const newLogs = addOrUpdate(logsObj, 'objectId', { objectId: obj.id, ...obj.attributes });

      this.setState({
        logs: newLogs,
        liveQueries: {
          ...liveQueries,
          LatestCreatedBuild: { ...obj.attributes, objectId: obj.id },
        },
        ...runningBuild,
        ...cancelled,
      });
    });

    this.refreshGraph();
  }

  componentWillUnmount() {
    if (this.client) {
      this.client.close();
      this.client = null;
    }

    if (this.subscriptionBuild) {
      this.subscriptionBuild.unsubscribe();
      this.subscriptionBuild = null;
    }

    if (this.subscriptionBuildLogStream) {
      this.subscriptionBuildLogStream.unsubscribe();
      this.subscriptionBuildLogStream = null;
    }
  }

  onStartBuildHandler = async () => {
    this.setState({
      runningBuild: true,
    });

    SashiDo.startBuild({ appId: this.context.currentApp.id });
  }

  closeHandler = async () => {
    this.refreshGraph();
    this.setState({
      runningBuild: false,
      liveQueries: {
        LatestCreatedBuild: {},
      },
    });
  }

  cancelHandler = async (name) => {
    const appId = this.context.currentApp.id;

    await SashiDo.cancelBuild({
      appId,
      name,
    });

    this.refreshGraph();

    this.setState({
      runningBuild: false,
      liveQueries: {
        LatestCreatedBuild: {},
      },
    });
  }

  refreshGraph = async () => {
    const appId = this.context.currentApp.id;
    const logs = await SashiDo.getBuilds({ appId });

    const labels = [];
    const datasets = [];
    const colors = [];
    const statuses = [];

    const logsArr = logs.length >= 15 ? [...logs].reverse().slice(-15) : [...logs].reverse();

    logsArr.forEach((item) => {
      statuses.push(item.phase);

      if (item.phase === 'New') {
        colors.push('#fd9539');
      } else if (item.phase === 'Pending') {
        colors.push('#0092ff');
      } else if (item.phase === 'Running') {
        colors.push('#0092ff');
      } else if (item.phase === 'Complete') {
        colors.push('#98d85b');
      } else if (item.phase === 'Failed') {
        colors.push('#ff5858');
      } else if (item.phase === 'Cancelled') {
        colors.push('#ccc');
      }

      labels.push(item.number);
      datasets.push(item.duration);
    });

    const firstLogs = {
      statuses,
      colors,
      labels,
      datasets: [
        {
          name: 'Build Time',
          values: datasets,
        },
      ],
    };

    this.setState({
      logs,
      firstLogs: logs.length >= 5 ? firstLogs : null,
    });
  }


  renderContent() {
    const {
      runningBuild,
      logs,
      firstLogs,
      liveQueries,
    } = this.state;

    return (
      <div>
        <Toolbar section={this.section} subsection={this.subsection}>
          <Button
            color="blue"
            value="Start Build"
            disabled={runningBuild}
            onClick={this.onStartBuildHandler} />
        </Toolbar>
        <div className={[styles.settings_page, this.state.showFooter ? styles.showFooter : ''].join(' ')}>
          <div className={styles.holder}>
            <LoaderContainer loading hideAnimation={this.state.loading} inner>


              {
                <div className={[stylesEngine.holder].join(' ')}>

                  <RealTimeLogView
                    liveQueries={liveQueries}
                    buildId={liveQueries.LatestCreatedBuild.objectId}
                    appId={this.context.currentApp.id}
                    slug={this.context.currentApp.slug}
                    cancelHandler={this.cancelHandler}
                    closeHandler={this.closeHandler} />

                  {
                    firstLogs &&
                      <div className={styles.refreshGraphHolder}>
                        <GraphBuilds
                          data={firstLogs}
                          unit=""
                          dataFormat="nanoSecondsFormat"
                          toolTipDataFormat="nanoSecondsFormat"
                          colors={['#98d85b']} />

                        <div className={styles.refreshGraph} onClick={this.refreshGraph}>
                          <Icon name="refresh-solid" width={14} height={14} fill="rgba(0,0,0,0.4)" />
                        </div>
                      </div>
                  }

                  <BuildsView
                    liveQueries={liveQueries}
                    buildId={liveQueries.LatestCreatedBuild.objectId}
                    appId={this.context.currentApp.id}
                    currentApp={this.context.currentApp}
                    logs={logs}
                    refreshGraph={this.refreshGraph} />
                </div>
              }
            </LoaderContainer>
          </div>
        </div>
      </div>
    );
  }
}
